import React, { useState, useCallback, useEffect, Fragment } from 'react';
import { Tree, Button, Modal, message, Spin } from 'antd';
import { CarryOutOutlined, PlusSquareOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import _ from "lodash";

import useWscCustomFormModal from '@/component/UseWscCustomForm';
import useRequest from "@/utils/useRequest";

// function list_to_tree(list) {
//   var map = {}, node, roots = [], i;

//   for (i = 0; i < list.length; i += 1) {
//     map[list[i].Id] = i; // initialize the map
//     list[i].key = list[i].Id;
//     //list[i].title = `[${list[i].Left}]    `+list[i].Name+`    [${list[i].Right}]`;
//     list[i].title = list[i].Name;
//     list[i].children = []; // initialize the children
//   }

//   for (i = 0; i < list.length; i += 1) {
//     node = list[i];
//     if (node.Pid !== -1) {
//       // if you have dangling branches check that map[node.Pid] exists
//       list[map[node.Pid]].children.push(node);
//     } else {
//       roots.push(node);
//     }
//   }
//   return roots;
// }

function list_to_tree(list) {
  var map = {}, node, roots = [], i;
  var ids = new Set(); // 用于存储所有节点Id

  // 遍历一遍列表，获取所有节点的Id
  for (i = 0; i < list.length; i += 1) {
    ids.add(list[i].Id);
  }

  // 遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    map[list[i].Id] = i; // initialize the map
    list[i].key = list[i].Id;
    list[i].title = list[i].Name;
    list[i].children = []; // initialize the children

    // 检查父节点是否存在于ids集合中，如果不存在则将该节点作为根节点处理
    if (list[i].Pid !== -1 && !ids.has(list[i].Pid)) {
      roots.push(list[i]);
    }
  }

  // 再次遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.Pid !== -1 && ids.has(node.Pid)) {
      list[map[node.Pid]].children.push(node);
    } else if (node.Pid === -1) {
      roots.push(node);
    }
  }

  return roots;
}


const CategoryTree = ({ value, onChange, edit = true, defaultExpandAll = true }) => {
  const { request } = useRequest();
  const [gData, setData] = useState([]);
  const [selectedKeys, setSelected] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [loading, setLoading] = useState(false);
  const Refresh = async () => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/category/all", "POST", "json", {});
      
      if (result.success) {
        //组装成树形结构
        //{ icon: <CarryOutOutlined />,disabled:true, key: "-1", title: orgName }
        let tree = list_to_tree(_.sortBy(result.data, item => parseInt(item.Left)));
        
        // 只有当value有值时才设置选中状态
        if (value) {
          setSelected([value.id]);
        } else {
          // 默认不选择任何项
          setSelected([]);
        }
        setLoading(false);
        setData(tree);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const Move = async (sourceId, targetId, pos) => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/category/move", "POST", "json", { sourceId: sourceId, targetId: targetId, pos: pos });
      if (result.success) {
        message.success("移动位置成功！");
        await Refresh();
      }
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const d = async (id) => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/category/delete", "POST", "json", { id: id });
      if (result.success) {
        message.success("删除成功！");
        await Refresh();
      } else {
        Modal.error({ content: result.message });
      }
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  useEffect(() => {
    Refresh();
  }, []);

  useEffect(() => {
    // 根据value的变化更新选中状态
    if (value) {
      setSelected([value.id]);
    } else {
      setSelected([]);
    }
  }, [value?.id]);

  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  return <Spin spinning={loading}>
    <div className="flex items justify-end bg-gray-50 py-1 mb-3 rounded-md">
      {edit ? (<Fragment>
        <Button type="link" icon={<PlusSquareOutlined />} onClick={() => {
          if (selectedKeys.length == 1) {
            showDynamicModal(72, { Pid: selectedKeys[0] });
          } else {
            showDynamicModal(72, { Pid: -1 });
          }
        }} size={'middle'} />
        <Button type="link" icon={<EditOutlined />} onClick={() => {
          if (selectedKeys.length == 1) {
            showDynamicModal(74, { ...selectedNode, Id: selectedKeys[0] });
          } else {
            message.info("请选中需要编辑的分类");
          }
        }} size={'middle'} />
        <Button type="link" icon={<DeleteOutlined />} onClick={() => {
          if (selectedKeys.length == 1) {
            Modal.confirm({
              title: '确认删除',
              icon: <ExclamationCircleOutlined />,
              content: `是否确认删除选中的分类信息？`,
              okText: '确认',
              cancelText: '取消',
              async onOk() {
                d(selectedKeys[0]);
              }
            });
          } else {
            Modal.error({ content: "请先选中需要删除的分类！" });
          }
        }} size={'middle'} />
      </Fragment>) : null}
    </div>
    {loading ? (
      <div className="text-center py-4 text-gray-500">加载中...</div>
    ) : gData.length === 0 ? (
      <div className="text-center py-8 text-gray-400">
        <div className="mb-2">暂无分类数据</div>
        {edit && (
          <Button 
            type="primary" 
            icon={<PlusSquareOutlined />} 
            onClick={() => showDynamicModal(72, { Pid: -1 })}
            size="small"
          >
            创建第一个分类
          </Button>
        )}
      </div>
    ) : (
      <Tree
        className='pr-3 pb-3'
        //   defaultExpandedKeys={expandedKeys}
        defaultExpandAll={defaultExpandAll}
        selectedKeys={selectedKeys}
        draggable={edit}
        blockNode
        multiple={false}
        onDragStart={(info) => {
          return info.node.Pid != -1;
        }}
        onDrop={(info) => {
          let pos = Number.parseInt(info.node.pos.slice(-1)) - info.dropPosition;
          //0:代表移动到目标节点子节点,放到第一的位置
          //-1:代表移动到目标节点下方插入
          //1:代表移动目标节点前插入
          console.log(info.node.pos.slice(-1), pos, `[${info.node.Id}]${info.node.Name}\t`);
          Move(info.dragNode.Id, info.node.Id, pos);
        }}
        onSelect={(selectedKeys, info) => {
          setSelected(selectedKeys);
          setSelectedNode(info.node);
          if (onChange) {
            if (selectedKeys.length > 0) {
              onChange(selectedKeys[0], info.node.Left, info.node.Right);
            } else {
              // 取消选择时，清除分类过滤条件
              onChange(null, null, null);
            }
          }
        }}
        treeData={gData}
      />
    )}
    {edit ? <WscCustomFormModal formId={72} OnPayload={(form, name, payload) => {
      //==============新增用户成功=======
      if (name == "OK") {

        if (payload.apiresult?.success == false) {
          Modal.error({ content: payload.apiresult.message });
          return;
        } else {
          message.success(payload.apiresult?.message);
          hide(72);
          Refresh();
          return;
        }
      }
      if (name == "Cancel") {
        hide(72);
        return;
      }
    }
    }
    /> : null}
    {edit ? <WscCustomFormModal formId={74} OnPayload={(form, name, payload) => {
      //==============修改分类成功=======
      if (name == "OK") {

        if (payload.apiresult?.success == false) {
          Modal.error({ content: payload.apiresult.message });
          return;
        } else {
          message.success(payload.apiresult?.message);
          hide(74);
          Refresh();
          return;
        }
      }
      if (name == "Cancel") {
        hide(74);
        return;
      }
    }
    }
    /> : null}

  </Spin>
}

export default CategoryTree;